class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.moneyFormat = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD'});
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.toggleItems = document.getElementById('toggle-cart-items');
    this.cartItemsHeader = document.querySelector('.js-cart-items-header');
    this.subtotal = document.querySelector('.js-subtotal');
    this.addGiftNote = document.getElementById('add_a_gift_note');
    this.packSavings = document.querySelector('.js-pack-savings');
    this.setSavings = document.querySelector('.js-cart-set-savings');
    this.setSavingsAmount = document.querySelector('.js-cart-set-savings-amount');

    // DY sitewide affected elements
    this.cartTotalPrice = document.querySelector('.js-cart-total-price');
    this.cartItems = document.querySelectorAll('.cart-item__name');
    this.promoSavings = document.querySelector('.js-cart-promo-savings');
    this.promoSavingsText = document.querySelector('.js-cart-promo-text');
    this.promoSavingsDiscountText = this.promoSavings.querySelector('.js-cart-promo-savings-text'),
    this.promoSavingsAmount = this.promoSavings.querySelector('.js-cart-promo-savings-amount'),
    this.cartItemPrice = document.querySelectorAll('.cart-item__price'),
    this.cartItemOgPrice = document.querySelectorAll('.cart-item__old-price'),
    this.cartItemOgDiscount = document.querySelectorAll('.discounts__discount'),
    this.promoLabelEl = document.querySelectorAll('.cart-item__promo-line > .promo-label > strong');
    this.hasNonGiftCards = Array.from(this.cartItems).some(item => !item.innerText.includes('Gift Card'));

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    this.toggleItems.addEventListener('click', this.onToggleItems.bind(this));
    this.addGiftNote?.addEventListener('click', this.onAddGiftNote.bind(this));

    // trigger DY sitewide promo onload
    document.addEventListener('dy:promo:init', () => {
      this.getSitewideDiscount();
    });

    // detects cart item change and retrigger DY sitewide promo
    if(this.hasNonGiftCards && window.Marlow?.promo?.swd) this.getSitewideDiscount();
    else this.showGiftCardTreatment();

  }

  onToggleItems(event) {
    event.preventDefault();
    if (this.cartItemsHeader.classList.contains('active')) {
      this.cartItemsHeader.classList.remove('active')
    } else {
      this.cartItemsHeader.classList.add('active')
    }
  }

  onAddGiftNote() {
    if (this.addGiftNote.checked) {
      document.querySelector('.header-cart__giftnote').classList.add('active')
    } else {
      document.querySelector('.header-cart__giftnote').classList.remove('active')
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'header-cart',
        section: document.getElementById('header-cart').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        window.__CART__ = parsedState;
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
        this.disableLoading();

        const statusBlock = document.querySelector('product-totals');
        const qty = document.querySelector('.js-true-quantity-input')?.value || 0;
        statusBlock?.updateText(parseInt(qty));
        document.querySelector(".js-cart-items-header").classList.add("active");
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        if (document.getElementById('cart-errors')) {
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
        }
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll('.loading-overlay')[line - 1].classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    if (document.getElementById('cart-items')) {
      document.getElementById('cart-items').classList.remove('cart__items--disabled');
    }
  }

  // DY Promo Object - Sitewide Discount
  getSitewideDiscount() {
    const { enabled, code, pdpSlashouts, amount, threshold } = window.Marlow.promo.swd,
          parsedAmount = parseFloat(amount),
          swdSlashEnabled = enabled.includes('true') && pdpSlashouts.includes('true'),
          codeAmountExist = parsedAmount > 0 && code !== '';
    let cartTotal = this.nonGiftCardCartTotal();

    const thresholdMet = parseFloat(threshold / 100) <= cartTotal,
          dYConditionsMet = swdSlashEnabled && codeAmountExist && thresholdMet;

    if(dYConditionsMet) {
      const swdAmount = parsedAmount > 100 ? parsedAmount / 100 : parsedAmount; // determines amount is % or $  
      let discount = parsedAmount > 100 ? swdAmount : 0;
      
      if(parsedAmount < 100) discount = this.updateCartItemsDiscount(discount, swdAmount);

      this.updateCartSummaryDiscount(discount, swdAmount, parsedAmount);
    }

    this.showGiftCardTreatment();
  }

  getPriceAmount(el) {
    const updatedPrice = el.innerHTML.replace(/\$/g, '')
    return parseFloat(updatedPrice)
  }

  showGiftCardTreatment() {
    // Gift card final sale treatment in cart, only display during SWD
    const giftCardElems = Array.from(this.cartItems).filter(item => item.innerText.includes('Gift Card'));

    if(window.Marlow?.promo?.swd && giftCardElems.length > 0) {
      giftCardElems.forEach(item => {
        const parentEl = item.parentElement,
              cartItem = parentEl.parentElement,
              cartPromoLine = cartItem.querySelector('.cart-item__promo-line');
        cartPromoLine.classList.remove('hidden');
      });
    }
  }

  nonGiftCardCartTotal() {
    // Recalculating cart total to exclude gift cards from threshold
    const giftCardElems = Array.from(this.cartItems).filter(item => item.innerText.includes('Gift Card'));
    let cartTotal = this.getPriceAmount(this.cartTotalPrice);

    if(giftCardElems.length > 0) {
      giftCardElems.forEach(item => {
        const itemQty = item.dataset.qty,
              dlElem = item.nextSibling,
              productOptionEl = dlElem.childNodes[0].children[1],
              giftCardValue = this.getPriceAmount(productOptionEl) * itemQty;
        cartTotal -= giftCardValue
      });
    }

    return cartTotal;
  }

  createSlashoutPrice(currentPrice, oldPriceEl) {
        const priceWrapperEl = oldPriceEl.parentElement,
          newSpan = document.createElement('s'),
          formattedPrice = parseFloat(currentPrice).toFixed(2);
    newSpan.className = "cart-item__old-price price price--end";
    newSpan.innerHTML = `$${formattedPrice}`;
    priceWrapperEl.insertBefore(newSpan, priceWrapperEl.firstChild)
  }

  updateCartItemsDiscount(discount, swdAmount) {
    // Update cart line item if swd discount is %off
    const { cartItemOgDiscount, cartItemPrice, cartItemOgPrice, promoLabelEl, promoSavings, promoSavingsAmount } = this;
    const dyPercentDiscount = window.Marlow?.promo?.swd?.amount ? (100 - parseInt(window.Marlow?.promo?.swd?.amount)) / 100 : 1;
    Array.from(cartItemPrice).forEach((el, i) => {
      //check to ensure the price elements are grouped together in the correct cart item.
      const currentPrice = this.cartItemPrice[i] ? this.getPriceAmount(this.cartItemPrice[i]) : oldPrice,
        oldPriceEl = cartItemOgPrice[i] && cartItemOgPrice[i].getAttribute("data-key") == el.getAttribute("data-key") ? cartItemOgPrice[i] : el,
        oldPrice = this.getPriceAmount(oldPriceEl);

      // if no slashout price exist, create one
      !oldPriceEl.parentElement.querySelector("s") ? this.createSlashoutPrice(oldPrice, oldPriceEl) : oldPriceEl.classList.remove("hidden");
      if (dyPercentDiscount) this.cartItemPrice[i].innerHTML = this.moneyFormat.format(parseFloat(currentPrice) * dyPercentDiscount.toFixed(2));

      // discount calculations and update cart line item to reflect promo pricing
      if (promoLabelEl[i]) {
        let discountAmount = currentPrice * (swdAmount / 100);
        if (discountAmount) discount += discountAmount;
        const savingsAmount = (currentPrice - discountAmount).toFixed(2),
          priceDiff = this.getPriceAmount(oldPriceEl.parentElement.querySelector("s")) - savingsAmount;
        el.innerHTML = `$${savingsAmount}`;
        promoLabelEl[i].innerHTML = `saving $${priceDiff.toFixed(2)}`;
      }
    })
    return discount;
  }
  updateCartSummaryDiscount(discount, swdAmount, parsedAmount) {
    // calculate discount amount for cart total and update cart order summary to reflect promo pricing
    const { cartTotalPrice, promoSavings, promoSavingsText, promoSavingsDiscountText, promoSavingsAmount, cartItems, subtotal} = this;
    if(window?.Marlow?.promo?.swd?.promoText) promoSavingsText.innerHTML = window.Marlow.promo.swd.promoText;
    promoSavingsDiscountText.innerHTML = parsedAmount > 100 ? `($${swdAmount})` : `(${swdAmount}%)`
    let roundedDiscountAmount = discount.toFixed(2);
    promoSavingsAmount.innerHTML = `-$${roundedDiscountAmount}`;
    const newPrice = this.getPriceAmount(cartTotalPrice);
    cartTotalPrice.innerHTML = `$${(newPrice - roundedDiscountAmount).toFixed(2)}`;

    fetch('/cart.js').then(cart => cart.json()).then(data => {

      //check if cart contains sleep system product, and show appropriate bundle savings
      if(data.items.some((cartItem) => cartItem.product_id == 7586823798971)){
        this.setSavings.classList.remove('hidden');
        let setSavings = 0;
        data.items.filter((cartItem) => cartItem.product_id == 7586823798971).forEach(item => {
          //if king size sleep system, bundle discount is 11 dollars times the quantity of the item
          //standard size sleep system bundle discount is 5 dollars times the quantity of the item
          item.variant_id == 43129429590203 ? setSavings += (11*item.quantity) : setSavings += (5*item.quantity);
        });
        this.setSavingsAmount.innerHTML = `-$${setSavings.toFixed(2)}`
      } else this.setSavings?.classList.add('hidden');
      
    });

    if(swdAmount){
      //if DY discount exists, use this logic to doublecheck and ensure that discount saving prices are showing correctly
      let newTotal = 0;
      const packSavings = this.packSavings ? this.getPriceAmount(this.packSavings) : 0;
      this.cartItemPrice.forEach(item => { newTotal += this.getPriceAmount(item); });
      cartTotalPrice.innerHTML = this.moneyFormat.format(newTotal);
      /* 
        Math for getting extra savings: d2 = s1 - s2 + d1
          - where d2 = extra savings,
          - s1 = the original subtotal without discounts,
          - s2 = the new total (i.e. the sum of all the product prices),
          - and d1 = the pack savings discount (this is a negative number usually, otherwise it's just 0)
        Doing it this way ensures that nothing gets wonky in the case we ever need to use money discount instead of percent
      */
      promoSavingsAmount.innerHTML = `-${this.moneyFormat.format(this.getPriceAmount(this.subtotal) + packSavings - newTotal)}`;
    }
    promoSavingsAmount.innerHTML == '-$0.00' ? promoSavings.classList.add('hidden') : promoSavings.classList.remove('hidden');
  }
}

customElements.define('cart-items', CartItems);

class CartUpsell extends HTMLElement {
  constructor() {
    super();
    this.bmsm = window.Marlow.bmsm;
    this.ref = {
      "41259510661307" : {"name": "pillow", "pid" : "7031097524411"},
      "41259510694075" : {"name": "pillow", "pid" : "7031097524411"},
      "43129416777915" : {"name": "Protector", "pid" : "7586819571899"},
      "43129416810683" : {"name": "Protector", "pid" : "7586819571899"},
      "43129429557435" : {"name": "System", "pid" : "7586823798971"},
      "43129429590203" : {"name": "System", "pid" : "7586823798971"},

      /*dev product and variant IDs*/
      "44521096511800" : {"name": "pillow", "pid" : "8131774251320"},
      "44521096544568" : {"name": "pillow", "pid" : "8131774251320"},
      "44521092841784" : {"name": "Protector", "pid" : "8131773825336"},
      "44521092874552" : {"name": "Protector", "pid" : "8131773825336"},
      "44521092088120" : {"name": "System", "pid" : "8131773727032"},
      "44521092153656" : {"name": "System", "pid" : "8131773727032"}
    };
    this.defineUpsellElements();
    this.defineCalculatorElements();
    (this.cartSize > 0) ? this.getUpsellItem() : this.getUpsellItemEmptyCart()
    this.itemActions.forEach((btn) => {
      btn.addEventListener('click', this.addToCart.bind(this, btn))
    });
  }

  checkDiscount(cart) {
    //check if any max discount has been hit for any product. upsell should be hidden if discountMaxed is set to true
    return cart.some(cartItem => cartItem.quantity >= 4);
  }

  getUpsellItem() {
    fetch('/cart.js').then(cart => cart.json()).then(data => {
      let items = data.items.filter(item => item.product_type != "Gift Cards");
      if(!this.checkDiscount(items)){
        let context;
        if (items.length == 1 ) context = items[0];
        else if(items.length > 1) {
          let pillowItems = items.filter(item => item.product_id == 7031097524411); 
          context = pillowItems.length ? pillowItems[pillowItems.length - 1] :  items[items.length - 1];
          this.matchedUpsellPIDs = items.filter(item => item.product_id == this.ref[context.id].pid);
        }
        return this.buildUpsellObject(context); 
      } else{
        //if 30% discount is reached for an item in cart, show the item in savings calculator
        this.firstDiscountedItem = items.filter(item => item.quantity >= 4)[0];
      }
    }).then(res => { 
      return this.updateUpsellHTML(res, false);
    }).then(obj => {
      this.updateCalculatorHTML(obj);
    });
  }

  getUpsellItemEmptyCart() {
    //empty cart, default to "The Pillow" product
    fetch('/products/the-pillow.json').then(data => data.json()).then(res => {
      const obj = {
        discount: `${this.bmsm.data.tier_2_discount}%`,
        id: res.product.variants[0].id,
        original_price: res.product.variants[0].price * 100,
        product_title: res.product.title,
        image: res.product.images[res.product.images.length - 1].src,
        cart_quantity: 0,
        quantity: 2,
        url: "/products/the-pillow?variant=43146923704507",
        variant_title: res.product.variants[0].title,
      };
      return obj;
    }).then(obj => {
      return this.buildUpsellObject(obj);
    }).then(res => {return this.updateUpsellHTML(res, true)});
  }
  defineUpsellElements() {
    this.upsellTitle = this.querySelector('.header-cart__upsell-item-info h5');
    this.upsellCopyWrapper = this.querySelector('.header-cart__upsell-item-info');
    this.upsellUrl = this.querySelector('.header-cart__upsell-item-info a');
    this.upsellImg = this.querySelector('.header-cart__upsell-item-img img')
    this.upsellCopy = this.querySelector('.header-cart__upsell-item-info p label')
    this.upsellVariantValue = this.querySelector('.header-cart__upsell-item-info--value');
    this.upsellQtyInput = this.querySelector('.header-cart__upsell-item-actions input');
    this.upsellQtySelect = this.querySelector('.header-cart__upsell-item-actions select');
    this.upsell = this.querySelector('.header-cart__upsell-wrapper');
    this.itemActions = this.querySelectorAll('.header-cart__upsell-item-actions button');
    this.cartSize = this.getAttribute('data-cart-count');
  }
  defineCalculatorElements() {
    this.calculator = document.querySelector('.header-cart__savings');
    this.calculatorLabels = document.querySelectorAll('.header-cart__savings-labels > div');
    this.calculatorBar = document.querySelector('.header-cart__savings-bars > div');
    this.calculatorStep = document.querySelector('.header-cart__savings-steps div');
  }
  
  updateCalculatorHTML(obj){
    //updates calculator label to accurately reflect what the upsell item is (ie Pillow,System,Protector)
    //updates bar progress and styling based off the quantity and discount of the upsell shown
    const activeLabelIndexes = 
    { "0" : [0,1],
      "1" : [2,3],
      "2" : [4] };
    let labelQty = 0;
    if(this.matchedUpsellPIDs) {
      this.matchedUpsellPIDs.forEach(product => {
        labelQty += parseInt(product.quantity);
      });
    } else labelQty = obj.qty;
    this.calculatorLabels.forEach((label, index) => {
      let labelHTML;
      index != 2 ? labelHTML = index + 1 + ` ${obj.name}${index == 0 ? '' : 's'}` : labelHTML = 4 + ` ${obj.name}s`;
      label.querySelector('small').innerHTML = labelHTML;
      label.querySelector('small').classList.remove('animation--loading');
      label.querySelector('small').classList.add('animation--loaded');
      //when looping through all 3 labels, darken the label only if the obj.qty is in the array of the index 
      activeLabelIndexes[index].includes(labelQty) ? label.classList.remove('color-text-subdued') : label.classList.add('color-text-subdued');
    });
    let barProgress = `${labelQty * 25}%`;
    this.calculatorBar.style.width = barProgress;
    this.calculatorStep.setAttribute('style', `left:${barProgress};transform:translateX(-${barProgress});`);
  }
  updateUpsellHTML(res, isEmpty){
    /* accepts 2 parameters
      res - upsell object. in the edge case where there is no res object,
      that means the 30% discount has been hit for an item that is not the current upsell. 
      isEmpty - if cart is empty, default to 2 standard pillows upsell
    */
    if(res){
      this.upsellTitle.innerHTML = `<a href="${res.url}" target="_blank">Add ${res.qty} more ${res.qty_name}${res.qty == 1 ? "" : "s"} for ${
        isEmpty ? (this.bmsm.tiers == 2 ? (this.bmsm.data.tier_1_discount) : this.bmsm.data.tier_2_discount) + '%' : res.discount
      } off</a>`;
      this.upsellImg.setAttribute('src', res.image);
      this.itemActions[0].setAttribute('data-variant-id', res.id);
      this.upsellQtyInput ? this.upsellQtyInput.value = res.qty : this.upsellQtySelect.value = res.qty;
      this.upsellQtyInput ? this.upsellQtyInput.setAttribute('id', `upsell_qty_${res.id}`) : this.upsellQtySelect.setAttribute('id', `upsell_qty_${res.id}`);
      this.upsellImg.classList.add('animation--loading');
      this.upsellImg.classList.add('animation--loaded');
      this.upsell.classList.remove('hidden');
    } else this.upsell.classList.add('hidden');
    this.upsellCopyWrapper.classList.add('animation--loaded');
    return {id: res ? res.id : "41259510661307", discount: res ? res.discount : this.bmsm.tiers == 2 ? this.bmsm.data.tier_2_discount : this.bmsm.data.tier_3_discount, qty: res ? res.cart_qty : 4, name: res ? res.qty_name : this.ref[this.firstDiscountedItem.id].name};
  }

  buildUpsellObject(context) {
    // context - JSON object of the upsell item. can be fetched via /cart.js or created custom and augmented w/ pdp .json
      let formatCurrency = new Intl.NumberFormat(undefined, {style: 'currency', currency: 'USD'});
      let discount_percentage;
      if(this.bmsm.tiers == 2){
        context.quantity < 2 ? discount_percentage = `${this.bmsm.data.tier_1_discount}%` : discount_percentage = `${this.bmsm.data.tier_2_discount}%`;
      } else {
        context.quantity < 2 ? discount_percentage = `${this.bmsm.data.tier_2_discount}%` : discount_percentage = `${this.bmsm.data.tier_3_discount}%`;

      }
      let upsellItem = {
        id: context.id,
        product_title: context.product_title,
        cart_qty: context.cart_quantity == 0 ? context.cart_quantity : context.quantity,
        qty: context.quantity == 3 ? 1 : context.quantity,
        qty_name: `${this.ref[context.id].name}`,
        discount: discount_percentage,
        image: context.image,
        discount_threshold: context.quantity == 1 ? 2 : 4,
        url: context.url,
        variant_title: context.variant_title,
        price: formatCurrency.format((context.original_price / 100) * (context.quantity == 3 ? 1 : context.quantity)),
      };
      return upsellItem;    
  }

  getSectionsToRender() {
    return [
      {
        id: 'header-cart',
        section: document.getElementById('header-cart').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  addToCart(btn) {
    const id = parseInt(btn.dataset.variantId) || 0
    const quantity = document.getElementById(`upsell_qty_${id}`)?.value || 0
    if (id && quantity) {
      btn.setAttribute('disabled', true);
      btn.classList.add('loading');

      const body = JSON.stringify({
        id,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          const cartItemsEl = document.querySelector('cart-items');
          if(cartItemsEl) cartItemsEl.showGiftCardTreatment();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          btn.classList.remove('loading');
          btn.removeAttribute('disabled');
        });
    }
  }
}

customElements.define('cart-upsell', CartUpsell);

class CartAddMore extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.addToCart.bind(this))
  }

  getSectionsToRender() {
    return [
      {
        id: 'header-cart',
        section: document.getElementById('header-cart').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  addToCart() {
    const id = parseInt(this.dataset.variantId) || 0
    const quantity = parseInt(this.dataset.qty) || 1
    if (id && quantity) {
      this.setAttribute('disabled', true);

      const body = JSON.stringify({
        id,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.removeAttribute('disabled');
        });
    }
  }
}

customElements.define('cart-add-more', CartAddMore);

class CartCheckoutButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.classList.add("loading");
      let note = ''
      if (document.getElementById('add_a_gift_note')?.checked) {
        note = this.trimValue(document.getElementById('cart_gift_note').value)
      }

      const body = JSON.stringify({
        note
      });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
      .then((response) => {
        const promo = window.Marlow?.promo,
              swd = promo?.swd;
        let urlParam = '';

        // promo object exists
        if(swd) {
          const swdEnabled = swd.enabled,
                discountCode = swd.code;
          // sitewide discount is enabled and a discount code exists
          urlParam = (swdEnabled.includes('true') && discountCode !== '') ? `?discount=${discountCode}` : ''   
        }

        location.href = `/checkout${urlParam}`
      }).catch((e) => {
          this.classList.remove("loading");
          console.error(e);
        });
    });
  }

  trimValue(str) {
    return str.replace(/^\s+|\s+$/g,"");
  }
}

customElements.define('cart-checkout-button', CartCheckoutButton);